import { styled } from 'stitches.config'

export const Wrapper = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '$tertiary-200',

  minHeight: '100vh',
  paddingTop: '$10',
  padding: '$10 $6',
  '@bp2': {
    paddingTop: '$14',
  },
})

export const TitleSection = styled('div', {
  '@bp2': {
    display: 'block',
    padding: '0 $14',
  },
})

export const ContactOptionsSection = styled('ul', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '$5',
  '& a': {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
  },
  '& svg': {
    margin: 'auto',
  },
  '@media screen and (max-width: 440px)': {},
})
